import React, { Component } from 'react';
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag';
import {
  injectStripe
} from 'react-stripe-elements';
import Button from '../../artzu-ui/src/Button'
import CheckBox from '../../artzu-ui/src/CheckBox'
import CardSection from './CardSection'
// import './profile.css';

class AddCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      processing: false,
      primary: this.props.primary || false,
      id: "",
      cvc: "",
      holder: "",
      postalCode: "",
      holderError: "",
      postalCodeError: "",
    }
  }

  render() {
    const { refetch, onClick } = this.props;
    const { primary, holder } = this.state;
    return (
      <Mutation
        mutation={ADD_SOURCE}
        onCompleted={async ({ addSource }) => {
          if (addSource.errors) {
            console.log(addSource.errors)
          } else {
            await refetch();
            onClick();
          }
        }}
      >
        {addSource => (
          <div className="card-form-container">
            <h3>Add New Card</h3>
            <CardSection holder={holder} onHolderChange={this.onHolderChange} />
            <div className="add-card-buttons">
              <Button 
                className="balance-button"
                padding="0"
                label="Cancel"
                color="#414141"
                onClick={onClick}
              />
              <Button
                className="balance-button"
                padding="0"
                label="Save"
                color="#128DFF"
                onClick={() => this.createSource(addSource)}
              />
            </div>
          </div>
        )}
      </Mutation>
    )
  }

  createSource = callback => {
    const { holder } = this.state;
    this.props.stripe.createSource(
        {
          owner: {
            email: this.props.currentUser.email,
            name: holder
          }
        }
      )
      .then(data => {
        callback({variables: {sourceId: data.source.id}})
      })
      .catch(err => {
        console.log(err)
      })
  }

  cardDetails() {
    const { cardNumber, expMonth, expYear, cvc, primary, holder, postalCode } = this.state;
    const card = {
      cardNumber,
      expMonth,
      expYear,
      cvc,
      primary,
      holder,
      postalCode
    };
    return card
  }

  onHolderChange = holder => {
    if(holder.length <= 24) this.setState({ holder })
  }

  handleCardNumberInput(e) {
    if(e.target.value.length <= 19) {
      this.setState({ cardNumber: e.target.value })
    }
  }
  handleExpDateInput(e) {
    const expMonth = e.target.value.slice(0,2)
    const expYear = e.target.value.slice(2)
    if(e.target.value.length <= 5) {
      this.setState({ expMonth, expYear })
    }
  }
  handleCvcInput(e) {
    if(e.target.value.length <= 3) {
      this.setState({ cvc: e.target.value })
    }
  }
  handleHolderInput(e) {
    if(e.target.value.length <= 30) {
      this.setState({ holder: e.target.value })
    }
  }
  handlePostalCodeInput(e) {
    if(e.target.value.length <= 7) {
      this.setState({ postalCode: e.target.value })
    }
  }
  validateFields() {
    this.setState({ holderError: "", cardNumberError: "", expDateError: "", cvcError: "", postalCodeError: "" })
    const { cardNumber, expMonth, expYear, cvc, primary, holder, postalCode } = this.state;
    if(holder.length < 1) {
      this.setState({ holderError: " " })
      return false;
    } else if(cardNumber.length < 16) {
      this.setState({ cardNumberError: " "})
      return false;
    } else if (expMonth.length < 2 || expYear.length < 2) {
      this.setState({ expDateError: " " })
      return false;
    } else if (cvc.length < 3) {
      this.setState({ cvcError: " " })
      return false;
    } else if (postalCode.length < 6) {
      this.setState({ postalCodeError: " " })
      return false;
    } 
    return true;
  }
}

const ADD_SOURCE = gql`
  mutation AddSource($sourceId: String!) {
    addSource(sourceId: $sourceId) {
      source {
        id
        card {
          last4
        }
      }
      errors
    }
  }
`;

export default injectStripe(AddCard);



// WEBPACK FOOTER //
// ./src/components/NewPayments/AddCard.js